export {
  RibbonColor,
  RibbonComponent,
  RibbonOrientation,
  RibbonPlacement,
} from './ribbon.component';
